var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TheHeader',{on:{"scroll-to-bottom":_vm.scrollToBottom,"change-section":_vm.updateSection}}),_c('main',[_c('HeroSection'),_c(_vm.currentSection,{tag:"component"})],1),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }